import {
  useAppContext,
  useTranslator,
  withLoading,
  createDateObject,
} from '@front-activerse/common-components';
import { Link } from 'react-router-dom';
import { PATH_DAY_PLAN_INDEX } from '../../MealPlanPaths';
import Timeline from '../../../Timeline';
import TimelinePlaceholder from '../../../Timeline/TimelinePlaceholder';
import TrackerDayDonutChart from '../../../Tracker/Index/components/TrackerDayDonutChart';

const DayPlanTimeline = ({ date, availableDays, additionalDatesCount = 14 }) => {
  const { t } = useTranslator();
  const {
    svgInline: { LeftArrow, RightArrow },
  } = useAppContext();

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const getDates = () => {
    const values = availableDays.map((day) => createDateObject(day.date));

    if (values.length !== 0) {
      const lastDateValue = values[values.length - 1].valueOf();

      for (let idx = 1; idx <= additionalDatesCount; idx += 1) {
        const d = new Date(lastDateValue);
        d.setDate(d.getDate() + idx);
        values.push(d);
      }
    }

    return values;
  };

  const renderPhase = (isoDate) => {
    const phaseDay = availableDays.find((day) => day.date === isoDate);
    if (phaseDay) {
      return phaseDay.dayPlan.diet.phase.identifier.toLowerCase();
    }

    return '';
  };

  return (
    <div className="timeline-container">
      <Timeline
        activeDate={createDateObject(date)}
        dates={getDates()}
        leftArrow={<LeftArrow />}
        rightArrow={<RightArrow />}
      >
        {({ active, isoDate, linkClassName, date: dateObj }) => {
          const isToday =
            dateObj.getFullYear() === today.getFullYear() &&
            dateObj.getMonth() === today.getMonth() &&
            dateObj.getDate() === today.getDate();
          const phaseClass = renderPhase(isoDate);
          return (
            <Link
              {...(active ? { 'aria-current': 'page' } : {})}
              to={`${PATH_DAY_PLAN_INDEX}/${isoDate}`}
              replace={true}
              className={`${linkClassName}${
                isToday ? ' timeline__link--today' : ''
              } ${phaseClass}`.trim()}
            >
              <span className="timeline-day-name">{t(`weekday${dateObj.getDay()}-short`)}</span>
              <div className="timeline-day-chart-wrapper">
                <TrackerDayDonutChart history={undefined} />
                <span className="timeline-day-number">{dateObj.getDate()}</span>
              </div>
            </Link>
          );
        }}
      </Timeline>
    </div>
  );
};

const Placeholder = () => {
  const {
    svgInline: { LeftArrow, RightArrow },
  } = useAppContext();
  return <TimelinePlaceholder leftArrow={<LeftArrow />} rightArrow={<RightArrow />} />;
};

export default withLoading(DayPlanTimeline, Placeholder);
